import { SessionService } from './../../../services/session.service';
import { QuestionnaireEnum } from './../../../services/api-names';
import { Observable, Observer } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Serializer } from '../../../helpers/serializer/seriealizer';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from '../../../tech-lib-portal.interceptor';
import { map } from 'rxjs/operators';
import { QuestionnaireInterface } from '../response/interfaces/questionnaire.interface';
import { QuestionnaireModel } from '../response/models/questionnaire.model';
import { QuestionnaireResultInterface } from '../request/interfaces/questionnaire-result.interface';
import { EvaluateResultInterface } from '../response/interfaces/evaluate-result.interface';
import { EvaluateResultModel } from '../response/models/evaluate-result.model';
import { Utils } from '../../../utils/utils';
import { ExtendedTestModel } from '../response/models/extendedTest.model';
import { ExtendedTestInterface } from '../response/interfaces/extendedTest.interface';
import {
  PortfolioModelServiceModelInterface,
  ServiceModelInterface,
} from '../response/interfaces/modelportfolio-servicemodel.interface';
import {
  PortfolioModelServiceModelModel,
  ServiceModelModel,
} from '../response/models/modelportfolio-servicemodel.model';
import { QuestionnaireSignatureInterface } from '../request/interfaces/questionnaire-signature.interface';
import { SignatureResultModel } from '../response/models/signature-result.model';
import { SignatureResultInterface } from '../response/interfaces/signature-result.interface';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.clientCode = this.session.clientCode;
  }

  getQuestionnaireInvestor(type: string): Observable<QuestionnaireInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi +
        QuestionnaireEnum.api_questionnaire_get_investor_profile,
      [type]
    );

    return new Observable((observer: Observer<QuestionnaireModel>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, QuestionnaireModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  getQuestionnaireInvestment(type: string): Observable<QuestionnaireInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi +
        QuestionnaireEnum.api_questionnaire_get_investment_profile,
      [type]
    );

    return new Observable((observer: Observer<QuestionnaireModel>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, QuestionnaireModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  evaluateQuestionnaire2(
    data: QuestionnaireResultInterface
  ): Observable<EvaluateResultInterface> {
    this.updateSession();

    const body = this.serializer.toJson(data);

    // console.log(body);

    return new Observable((observer: Observer<EvaluateResultModel>) => {
      this.httpClient
        .post(
          this.config.baseApi +
            QuestionnaireEnum.api_questionnaire_evaluate_profile,
          body
        )
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, EvaluateResultModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  setSignature(
    portfoliocode: string,
    data: QuestionnaireSignatureInterface
  ): Observable<SignatureResultInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi + QuestionnaireEnum.api_questionnaire_set_signature,
      [portfoliocode]
    );

    const body = this.serializer.toJson(data);

    // console.log(body);

    return new Observable((observer: Observer<SignatureResultModel>) => {
      this.httpClient
        .post(url, body)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, SignatureResultModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  getServiceModelPortfolio(
    serviceModelId: string
  ): Observable<PortfolioModelServiceModelInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi +
        QuestionnaireEnum.api_questionnaire_get_ServiceModelPortfolio,
      [serviceModelId]
    );

    return new Observable(
      (observer: Observer<PortfolioModelServiceModelModel>) => {
        this.httpClient
          .get(url)
          .pipe(
            map((resp: any) => {
              const t = this.serializer.fromJson(
                resp,
                PortfolioModelServiceModelModel
              );
              return t;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  getExtendedTest(testId: string): Observable<ExtendedTestInterface> {
    this.updateSession();

    const url = Utils.formatString(
      this.config.baseApi + QuestionnaireEnum.api_questionnaire_extendedtest,
      [testId]
    );

    return new Observable((observer: Observer<ExtendedTestModel>) => {
      this.httpClient
        .get(url)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, ExtendedTestModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }
}
